export default __webpack_public_path__ + "static/media/CIcon.094c84e8.png";